import React, {useEffect, useRef, useState} from 'react';
import ConfirmPopup from './ConfirmPopup.js';
import FormTextArea from './FormTextArea.js';

export default function HomeRes({showRes, closeRes, data, dataHours, updateReservations, deleteReservations, usrInfo}) {
	const popupAnimationMs = 300;
	const [lng, setLng] = useState(90);
	const [addPerson, setAddPerson] = useState(0);
	const [lockType, setLockType] = useState(0);
	const [selectedClientIds, setSelectedClientIds] = useState([]);
	const [errorMsg, setErrorMsg] = useState('');
	const [showConfirmPopup, setShowConfirmPopup] = useState(false);
	const [shouldRenderResPopup, setShouldRenderResPopup] = useState(showRes);
	const [isClosingResPopup, setIsClosingResPopup] = useState(false);
	const [dtFrom, setDtFrom] = useState('');
	const [tmFrom, setTmFrom] = useState('');
	const [tmTo, setTmTo] = useState('');
	const [lessonNote, setLessonNote] = useState('');

	const lessonNoteRef = React.createRef();
	const closeTimeoutRef = useRef(null);
	const canDeleteOnly = parseInt(data.slotLockedByEvent) === 1 && parseInt(data.id) > 0;
	const isInstructorUser = parseInt(usrInfo.instructor) === 1;
	const instructorClients = Array.isArray(data.instructorClients) ? data.instructorClients : [];
	const canSelectReservationClients = isInstructorUser && parseInt(data.lock) === 0 && parseInt(lockType) === 0 && instructorClients.length > 0;

	const sanitizeSelectedClientIds = (targetSelectedIds, selectionLimit = addPerson) => {
		const allowedClientIds = new Set(instructorClients.map((client) => parseInt(client.ID, 10) || 0));
		const nextSelectedIds = [];
		const seenIds = new Set();

		targetSelectedIds.forEach((value) => {
			const clientId = parseInt(value, 10) || 0;

			if (clientId > 0 && allowedClientIds.has(clientId) && !seenIds.has(clientId) && nextSelectedIds.length < selectionLimit) {
				seenIds.add(clientId);
				nextSelectedIds.push(clientId);
			}
		});

		return nextSelectedIds;
	};

	useEffect(() => {
		return () => {
			if (closeTimeoutRef.current) {
				clearTimeout(closeTimeoutRef.current);
			}
		};
	}, []);

	useEffect(() => {
		if (closeTimeoutRef.current) {
			clearTimeout(closeTimeoutRef.current);
			closeTimeoutRef.current = null;
		}

		if (showRes) {
			setShouldRenderResPopup(true);
			setIsClosingResPopup(false);
			return;
		}

		if (!shouldRenderResPopup) {
			return;
		}

		setIsClosingResPopup(true);
		closeTimeoutRef.current = setTimeout(() => {
			setShouldRenderResPopup(false);
			setIsClosingResPopup(false);
			closeTimeoutRef.current = null;
		}, popupAnimationMs);
	}, [popupAnimationMs, shouldRenderResPopup, showRes]);

	useEffect(() => {
		setLng(data.lng || 90);
		setAddPerson(data.addPerson || 0);
		setLockType(data.lock || 0);
		setSelectedClientIds(sanitizeSelectedClientIds(Array.isArray(data.selectedClientIds) ? data.selectedClientIds : [], data.addPerson || 0));
		setDtFrom(data.dt);
		setTmFrom(data.tm);
		setLessonNote(data.lessonNote || '');

		let dt = new Date(data.dt);
		dt.setMinutes(dt.getMinutes() + parseInt(data.lng));
		setTmTo(dt.toTimeString().substring(0, 5));

		setErrorMsg('');
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showRes]);

	const handleSubmit = (e) => {
		e.preventDefault();

		if (canDeleteOnly) {
			setErrorMsg('Slot je mezitim uzamceny. Tuto rezervaci muzes pouze smazat.');
			return;
		}

		if (parseInt(lockType) !== 0 || parseInt(data.lock) !== 0) {
			setErrorMsg('');
			updateReservations(data.id, dtFrom, lng, addPerson, lockType, lessonNote, [])
				.then(() => {
					closeRes();
				})
				.catch((error) => {
					setErrorMsg(error?.response?.data?.error || 'Rezervaci se nepodarilo ulozit.');
				});
			return;
		}

		let canAddMax = true;
		let canAddSame = true;
		let canLocked = true;

		setErrorMsg('');

		const overlapsSelectedRange = (item) => {
			return new Date(item.DT1).getTime() >= new Date(dtFrom).getTime() && new Date(item.DT1).getTime() <= new Date(dtFrom).getTime() + (lng - 30) * 60 * 1000;
		};

		const canUseLockedSlot = (item) => {
			if (parseInt(item.LOCKED) !== 1) {
				return true;
			}

			return item.LOCK_SOURCE === 'reservation' && parseInt(item.LOCKED_ID) === parseInt(data.id) && parseInt(item.CRBY) === parseInt(usrInfo.usrId);
		};

		if (parseInt(data.id) === 0) {
			dataHours.forEach((item, index) => {
				if (overlapsSelectedRange(item)) {
					if (item.USERS_CNT + addPerson + 1 > data.usr_max) {
						canAddMax = false;
					}

					item.USERS.forEach((item2, index2) => {
						if (parseInt(item2.USRID) === parseInt(usrInfo.usrId)) {
							canAddSame = false;
						}
					});

					if (!canUseLockedSlot(item)) {
						canLocked = false;
					}
				}
			});
		} else {
			dataHours.forEach((item, index) => {
				if (overlapsSelectedRange(item)) {
					const currentReservation = item.USERS.find((item2) => parseInt(item2.USRID) === parseInt(usrInfo.usrId) && parseInt(item2.ID) === parseInt(data.id));
					let actCnt = parseInt(item.USERS_CNT);

					if (currentReservation) {
						actCnt = actCnt + parseInt(addPerson) - parseInt(currentReservation.ADD_PERSON);
					} else {
						actCnt = actCnt + parseInt(addPerson) + 1;
					}

					if (actCnt > data.usr_max) {
						canAddMax = false;
					}

					item.USERS.forEach((item2, index2) => {
						if (parseInt(item2.USRID) === parseInt(usrInfo.usrId) && parseInt(item2.ID) !== parseInt(data.id)) {
							canAddSame = false;
						}
					});

					if (!canUseLockedSlot(item)) {
						canLocked = false;
					}
				}
			});
		}

		if (!canAddMax) {
			setErrorMsg('Maximální počet rezervací ve zvolený čas je ' + data.usr_max + '. Prosím zvolte jiný čas.');
		} else {
			if (!canAddSame) {
				setErrorMsg('Ve zvolený čas již máte rezervaci.');
			} else {
				if (!canLocked) {
					setErrorMsg('Ve zvolený čas je zavřeno.');
				}
			}
		}

		if (canAddMax && canAddSame && canLocked) {
			updateReservations(data.id, dtFrom, lng, addPerson, lockType, lessonNote, selectedClientIds)
				.then(() => {
					closeRes();
				})
				.catch((error) => {
					setErrorMsg(error?.response?.data?.error || 'Rezervaci se nepodarilo ulozit.');
				});
		}
	};

	const handleConfirmPopup = (e) => {
		e.preventDefault();
		setShowConfirmPopup(true);
	};

	const closeConfirmPopup = () => {
		setShowConfirmPopup(false);
	};

	const deleteConfirmPopup = () => {
		if (data.id > 0) {
			closeConfirmPopup();
			closeRes();
			deleteReservations(data.id, lockType);
		}
	};

	const setLngVal = (e, lng) => {
		e.preventDefault();
		setLng(lng);

		let dt = new Date(dtFrom);
		dt.setMinutes(dt.getMinutes() + lng);
		setTmTo(dt.toTimeString().substring(0, 5));
	};

	const setAddPersonVal = (e, addPerson) => {
		e.preventDefault();

		if (parseInt(data.lock) === 0 && parseInt(lockType) === 0 && parseInt(lockType) === 0) {
			setAddPerson((oldValue) => {
				if (addPerson === oldValue) {
					setSelectedClientIds([]);
					return 0;
				} else {
					setSelectedClientIds((prevSelectedIds) => sanitizeSelectedClientIds(prevSelectedIds, addPerson));
					return addPerson;
				}
			});
		}
	};

	const setLockTypeVal = (e, lockType) => {
		e.preventDefault();

		if (parseInt(data.lock) === 0) {
			setLockType((oldValue) => {
				if (parseInt(lockType) === parseInt(oldValue) && parseInt(data.lock) === 0) {
					return 0;
				} else {
					setAddPerson(0);
					setSelectedClientIds([]);
					return lockType;
				}
			});
		}
	};

	const toggleClientSelection = (clientId) => {
		if (parseInt(addPerson, 10) === 0 || !canSelectReservationClients) {
			return;
		}

		setSelectedClientIds((prevSelectedIds) => {
			if (prevSelectedIds.includes(clientId)) {
				return prevSelectedIds.filter((selectedId) => selectedId !== clientId);
			}

			if (prevSelectedIds.length >= parseInt(addPerson, 10)) {
				return prevSelectedIds;
			}

			return [...prevSelectedIds, clientId];
		});
	};

	function setDTTM(val) {
		let year = val.getFullYear();
		let month = (val.getMonth() + 1).toString().padStart(2, '0');
		let day = val.getDate().toString().padStart(2, '0');
		let hour = val.getHours().toString().padStart(2, '0');
		let minute = val.getMinutes().toString().padStart(2, '0');
		let formattedDate = `${year}-${month}-${day} ${hour}:${minute}:00`;

		setDtFrom(formattedDate);
		setTmFrom(val.toTimeString().substring(0, 5));

		let dt = new Date(formattedDate);
		dt.setMinutes(dt.getMinutes() + parseInt(lng));
		setTmTo(dt.toTimeString().substring(0, 5));
	}

	const prevHalf = () => {
		let act = new Date(dtFrom);
		let today = new Date(dtFrom);
		today.setHours(0, 30, 0, 0);

		if (act.getTime() < today.getTime()) {
			return;
		}

		let dt = new Date(dtFrom);
		dt.setMinutes(dt.getMinutes() - 30);

		setDTTM(dt);
	};

	const nextHalf = () => {
		let act = new Date(dtFrom);
		let today = new Date(dtFrom);
		today.setHours(23, 0, 0, 0);

		if (act.getTime() > today.getTime()) {
			return;
		}

		let dt = new Date(dtFrom);
		dt.setMinutes(dt.getMinutes() + 30);

		setDTTM(dt);
	};

	let lngsL = [];
	let lngsR = [];

	for (let i = 30; i <= 120; i = i + 30) {
		let hour = Math.floor(i / 60);
		let min = i - hour * 60;
		if (min === 0) {
			min = '';
		} else {
			min = '.5';
		}

		lngsL.push(
			<>
				<div key={`lngs_` + i}>
					<div className="fl_l mr_2 cr_p" onClick={(e) => setLngVal(e, i)}>
						<button type="button" className={`button check ${parseInt(lng) === i ? 'green' : ''} fl_l mr_05`}>&nbsp;</button>
						<span className="fl_l mt_02">
							{hour}
							{min} h
						</span>
					</div>
					<div className="zero h05" />
				</div>
			</>
		);
	}

	for (let i = 150; i <= 240; i = i + 30) {
		let hour = Math.floor(i / 60);
		let min = i - hour * 60;
		if (min === 0) {
			min = '';
		} else {
			min = '.5';
		}

		lngsR.push(
			<>
				<div key={`lngs_` + i}>
					<div className="fl_l mr_2 cr_p" onClick={(e) => setLngVal(e, i)}>
						<button type="button" className={`button check ${parseInt(lng) === i ? 'green' : ''} fl_l mr_05`}>&nbsp;</button>
						<span className="fl_l mt_02">
							{hour}
							{min} h
						</span>
					</div>
					<div className="zero h05" />
				</div>
			</>
		);
	}

	let addpersonsL = [];
	let addpersonsR = [];

	for (let i = 1; i <= 4; i++) {
		addpersonsL.push(
			<div key={`addpersons_` + i}>
				<div className={`fl_l mr_2 cr_p ${parseInt(lockType) > 0 ? 'button_disabled' : ''}`} onClick={(e) => setAddPersonVal(e, i)}>
					<button type="button" className={`button check ${parseInt(addPerson) === i ? 'green' : ''} fl_l mr_05`}>&nbsp;</button>
					<span className="fl_l mt_02">+{i}x doprovod</span>
				</div>
				<div className="zero h05" />
			</div>
		);
	}

	for (let i = 5; i <= 8; i++) {
		addpersonsR.push(
			<div key={`addpersons_` + i}>
				<div className={`fl_l mr_2 cr_p ${parseInt(lockType) > 0 ? 'button_disabled' : ''}`} onClick={(e) => setAddPersonVal(e, i)}>
					<button type="button" className={`button check ${parseInt(addPerson) === i ? 'green' : ''} fl_l mr_05`}>&nbsp;</button>
					<span className="fl_l mt_02">+{i}x doprovod</span>
				</div>
				<div className="zero h05" />
			</div>
		);
	}

	let lockTypes = [];
	const isAdminUser = parseInt(usrInfo.sysAdmin) === 1 || parseInt(usrInfo.usrId) === 1 || parseInt(usrInfo.usrId) === 4;
	const selectedClientCount = selectedClientIds.length;
	const clientSelectionCards = instructorClients.map((client) => {
		const clientId = parseInt(client.ID, 10) || 0;
		const isSelected = selectedClientIds.includes(clientId);
		const isDisabled = !isSelected && selectedClientCount >= parseInt(addPerson, 10);
		const hasPermanentMember = parseInt(client.PERNAMENTMEMBER, 10) === 1;
		const clientName = `${client.LASTNAME || ''} ${client.FIRSTNAME || ''}`.trim();
		const clientNickname = client.NICKNAME !== '' ? ` (${client.NICKNAME})` : '';

		return (
			<button
				type="button"
				key={`reservation_client_${clientId}`}
				className={`reservation-popup__client-option${isSelected ? ' is-selected' : ''}${isDisabled ? ' is-disabled' : ''}`}
				onClick={() => toggleClientSelection(clientId)}
				disabled={isDisabled}
			>
				<span className="reservation-popup__client-option-name">
					{hasPermanentMember ? <img className="icon2 permanent active reservation-popup__client-option-icon" alt="" /> : null}
					<span className="reservation-popup__client-option-name-text">{clientName}{clientNickname}</span>
				</span>
			</button>
		);
	});

	for (let i = 1; i <= 2; i++) {
		if ((i === 1 && isInstructorUser) || (i === 2 && isAdminUser)) {
			lockTypes.push(
				<div key={`lockTypes_` + i}>
					<div className="fl_l mr_2 cr_p" onClick={(e) => setLockTypeVal(e, i)}>
						<button type="button" className={`button check ${parseInt(lockType) === i ? 'green' : ''} fl_l mr_05`}>&nbsp;</button>
						{i === 1 &&
							<>
								<span className="fl_l mt_02">Lekce</span>
								<div className="zero h2" />
							</>
						}
						{i === 2 && <span className="fl_l mt_02">Zavřeno</span>}
					</div>
					<div className="zero h05" />
				</div>
			);
		}
	}

	return (
		<>
			<ConfirmPopup
				showConfirmPopup={showConfirmPopup}
				closeAnimationMs={popupAnimationMs}
				showButtonDelete
				deleteConfirmPopup={deleteConfirmPopup}
				closeConfirmPopup={closeConfirmPopup}
				infoHeader="Smazání rezervace"
				infoMain="Opravdu chceš smazat tuto rezervaci?"
				popupClassName="home-glass-popup reservation-popup reservation-popup--confirm"
				popupContentClassName="home-glass-popup__content reservation-popup__content reservation-popup__content--confirm"
				bodyClassName="home-glass-popup__body reservation-popup__body"
				bodyInnerClassName="home-glass-popup__body-in reservation-popup__body-in reservation-popup__body-in--confirm"
			/>

				{shouldRenderResPopup ? (
				<div className={`popup home-glass-popup reservation-popup${isClosingResPopup ? ' popup--closing reservation-popup--closing' : ''}`}>
					<div className={`popup_content home-glass-popup__content reservation-popup__content${isClosingResPopup ? ' popup_content--closing reservation-popup__content--closing' : ''}`}>
						<form method="POST" onSubmit={handleSubmit} className="reservation-popup__form">
							<div className="popup_content_in_head">
								<div className="popup_content_in_head_in">{data.id > 0 ? 'Editace' : 'Nová'} rezervace</div>
								<img
									alt=""
									className="popup_content_in_head_in-close"
									onClick={() => {
										closeRes();
									}}
								/>
							</div>
							<div className="popup_content_in_body home-glass-popup__body reservation-popup__body">
								<div className="popup_content_in_body_in home-glass-popup__body-in reservation-popup__body-in">
									<div className="zero h1" />
									<div className="fl_l reservation-popup__time-row">
										<span className="fl_l mt_02">Rezervace od&nbsp;</span>
										<span className="fl_l txt_l fnt_yellow mt_02 reservation-popup__time-value">{tmFrom}</span>
										<span className="fl_l mt_02">&nbsp;do&nbsp;</span>
										<span className="fl_l txt_l fnt_yellow mr_1 mt_02 reservation-popup__time-value" style={{width: '4.8rem'}}>
											{tmTo}
										</span>

										{tmFrom !== '00:00' ? (
											<div className="fl_l txt_c mr_1" style={{width: '3rem'}} onClick={() => prevHalf()}>
												<img className="icon_left cr_p" alt="" />
											</div>
										) : (
											<div className="fl_l txt_c mr_1" style={{width: '3rem'}}>
												<img className="icon_left disabled" alt="" />
											</div>
										)}

										{tmFrom !== '23:30' ? (
											<div className="fl_l txt_c mr_1" style={{width: '3rem'}} onClick={() => nextHalf()}>
												<img className="icon_right cr_p" alt="" />
											</div>
										) : (
											<div className="fl_l txt_c mr_1" style={{width: '3rem'}}>
												<img className="icon_right disabled" alt="" />
											</div>
										)}
									</div>

									<div className="zero h2" />

									<div className="fl_l" style={{ width: '16rem' }}>{lngsL}</div>
									<div className="fl_l">{lngsR}</div>

									<div className="zero h2" />

									<div className="fl_l" style={{ width: '16rem' }}>{addpersonsL}</div>
									<div className="fl_l">{addpersonsR}</div>

									{canSelectReservationClients && parseInt(addPerson, 10) > 0 ? (
										<>
											<div className="zero h1" />
											<div className="reservation-popup__client-panel">
												<div className="reservation-popup__client-panel-head">
													<div className="reservation-popup__client-panel-title">Klienti k doprovodu</div>
													<div className="reservation-popup__client-panel-count">Vybráno {selectedClientCount} z {addPerson}</div>
												</div>
												<div className="reservation-popup__client-panel-caption">Volitelné. Můžeš nechat bez výběru, vybrat jen některé nebo obsadit všechny doprovody.</div>
												<div className="reservation-popup__client-grid">{clientSelectionCards}</div>
											</div>
										</>
									) : null}

									{parseInt(data.id) === 0 || (data.id > 0 && data.lock > 0) ? (
										<>
											{lockTypes.length > 0 ?
												<>
													<div className="zero h2" />
													<div className="fl_l" style={{ width: '15rem' }}>
														{lockTypes}
													</div>
													{lockTypes.length > 0 && parseInt(lockType) === 1 ?
														<div className="fl_r" style={{ width: '100%', height: '10rem' }}>
															<div className="zero h1" />
															<FormTextArea type="text" label="Poznámka k lekci" height="8rem" value={lessonNote} setValue={setLessonNote} ref={lessonNoteRef} error="" />
														</div>
													:
														<div className="fl_r" style={{ width: '100%', height: '10rem' }}>
															<div className="zero h0" />
														</div>
													}
													<div className="zero h05" />
												</>
											: ''}
										</>
									) : (
										''
									)}

									<div className="zero h1" />
									{canDeleteOnly ? <span className="fnt_orange">Slot je mezitim uzamceny. Rezervaci muzes pouze smazat.</span> : ''}
									{canDeleteOnly ? <div className="zero h1" /> : ''}
									<span className="fnt_orange">{errorMsg}&nbsp;</span>
								</div>
							</div>
							<div className="popup_content_in_foot">
								<div className="popup_content_in_foot_in">
									<input type="submit" name="button_save" value="Uložit" className="button green mr_2" disabled={canDeleteOnly} />
									{data.id > 0 ? (
										<button
											type="button"
											className="button red mr_2"
											onClick={(e) => {
												handleConfirmPopup(e);
											}}
										>
											Smazat
										</button>
									) : (
										''
									)}
									<button
										type="button"
										className="button"
										onClick={() => {
											closeRes();
										}}
									>
										Zpět
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			) : (
				''
			)}
		</>
	);
}
